import React from 'react'
import { BANKING_BOTTOM_CONTENT, DIGITAL_COURSE_PAGE_3, DIGITAL_DETAILS_PAGE_3, DIGITAL_HERO_PAGE_3 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { DIGITAL_ACCORDIAN_3 } from '../../../utils/courseConifg'

const DigitalPage_3 = () => {
  return (
    <div className='outlet-render'>
             <CourseAsideHero  {...DIGITAL_HERO_PAGE_3}/>
      <CoursesAside {...DIGITAL_COURSE_PAGE_3}/>
      <CourseCard {...DIGITAL_DETAILS_PAGE_3}/>
      <Accordian {...DIGITAL_ACCORDIAN_3}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DigitalPage_3